import * as primitives from "@mirage/service-typeahead-search/service/primitives";
import { CacheKey } from "@mirage/service-typeahead-search/service/typeahead-cache";
import {
  SourceId,
  typeahead,
} from "@mirage/service-typeahead-search/service/types";
import * as wrappers from "@mirage/service-typeahead-search/service/utils/wrappers";
import type { Recommendation } from "@mirage/shared/search/recommendation";
import * as rx from "rxjs";
import { v5 as uuidv5 } from "uuid";
import {
  filterRecommendations,
  tagAndInjectHitsFactory,
} from "../utils/recommendation-helpers";
import { getResultSection } from "../utils/section-mapper";
import { getSourceLimit } from "../utils/source-helpers";

const DRAFT_NAMESPACE = "1b871a24-50d5-492e-99b0-da01ff1f5442";

const FILTER_RESULT_LIMIT = 200;

/**
 * API
 */

export const raw: typeahead.TaggedSearch = (query, mode, options) => {
  return rx.defer(() => {
    const { cache, grossLimit, sectionLimit, config } = options;

    const allRecommendations = cache.all(
      CacheKey.OmniboxRecommendations,
    ) as Recommendation<"omnibox">[];

    const recommendations = filterRecommendations(
      allRecommendations,
      query,
      mode,
      options,
      {
        onlyDocuments: true,
        allowContacts: true,
        filterResultLimit: FILTER_RESULT_LIMIT,
      },
    );

    const sourceLimit = getSourceLimit(
      typeahead.ResultType.DraftWithSource,
      query,
      mode,
      config,
      grossLimit,
      sectionLimit,
    );

    const sectionId = getResultSection(
      typeahead.ResultType.DraftWithSource,
      mode,
      query,
      config,
    );

    const tagAndInjectHits = tagAndInjectHitsFactory(
      primitives.draftWithSource,
      (result) => uuidv5(result.uuid, DRAFT_NAMESPACE),
      sourceLimit,
      sectionId,
    );

    return rx.of(tagAndInjectHits(recommendations, query, mode, options));
  });
};

export const search = wrappers.wrapped(SourceId.DraftWithSource, raw);
